import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Courses from "../views/Courses.vue";
import Course from "../views/Course.vue";
import CourseSignup from "../views/CourseSignup.vue";
import MultiRegistration from "../views/MultiRegistration.vue";
import RegistrationComplete from "../views/RegistrationComplete.vue";

// 使用者
import Member from "../views/user/Member.vue";
import Order from "../views/user/Order.vue";
import Favorite from "../views/user/Favorite.vue";
import Profile from "../views/user/Profile.vue";
import MyCourses from "../views/user/Courses.vue";
import MyRegistration from "../views/user/Registration.vue";
import MyRegistrationDetailed from "../views/user/RegistrationDetailed.vue";
import ActivateUser from "../views/ActivateUser.vue";

// 最新消息
import News from "../views/News.vue";
import NewsDetail from "../views/NewsDetail.vue";

// 系列課程
import CourseSeries from "../views/CourseSeries.vue";
import CourseSeriesDetails from "../views/CourseSeriesDetails.vue";

// 購物車
import Cart from "../views/Cart.vue";

// 營隊
import Camps from "../views/camp/Camps.vue";
import CampOverview from "../views/camp/CampOverview.vue";
import CampPrograms from "../views/camp/CampPrograms.vue";
import CampProgram from "../views/camp/CampProgram.vue";
import CampCart from "../views/camp/CampCart.vue";
import CampCheckout from "../views/camp/CampCheckout.vue";
import CampRegistrationComplete from "../views/camp/CampRegistrationComplete.vue";
import MyCampRegistration from "../views/camp/MyCampRegistration.vue";
import MyCampOrder from "../views/camp/MyCampOrder.vue";
import MyCampOrderDetail from "../views/camp/MyCampOrderDetail.vue";
import CampPaymentReport from "../views/camp/CampPaymentReport.vue";
import MyCampCoupon from "../views/camp/MyCampCoupon.vue";
import CampFavorite from "../views/camp/CampFavorite.vue";
import CampRelations from "../views/camp/CampRelations.vue";
import CampRelationForm from "../views/camp/CampRelationForm.vue";
import AccountSecurity from "../views/user/AccountSecurity.vue";
import MemberNotification from "../views/user/MemberNotification.vue";
import MemberNotificationDetail from "../views/user/MemberNotificationDetail.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // cart
  {
    path: "/cart",
    name: "cart",
    component: Cart,
  },

  // 營隊
  {
    path: "/camps",
    name: "Camps",
    component: Camps,
  },
  {
    path: "/campOverview",
    name: "CampOverview",
    component: CampOverview,
  },
  {
    path: "/campPrograms",
    name: "CampPrograms",
    component: CampPrograms,
  },
  {
    path: "/campProgram",
    name: "CampProgram",
    component: CampProgram,
  },
  {
    path: "/campCart",
    name: "CampCart",
    component: CampCart,
  },
  {
    path: "/campCheckout",
    name: "CampCheckout",
    component: CampCheckout,
  },
  {
    path: "/campRegistrationComplete",
    name: "CampRegistrationComplete",
    component: CampRegistrationComplete,
  },
  {
    path: "/campRegistration",
    name: "CampRegistration",
    component: MyCampRegistration,
  },
  {
    path: "/campOrder",
    name: "CampOrder",
    component: MyCampOrder,
  },
  {
    path: "/campOrderDetail",
    name: "CampOrderDetail",
    component: MyCampOrderDetail,
  },
  {
    path: "/campPayment/:paymentId/report",
    name: "CampPaymentReport",
    component: CampPaymentReport,
  },
  {
    path: "/campCoupon",
    name: "CampCoupon",
    component: MyCampCoupon,
  },
  {
    path: "/campFavorite",
    name: "CampFavorite",
    component: CampFavorite,
  },
  {
    path: "/myCampRegistration",
    redirect: { name: "CampRegistration" },
  },
  {
    path: "/myCampOrder",
    redirect: { name: "CampOrder" },
  },
  {
    path: "/courses",
    name: "courses",
    component: Courses,
  },
  {
    path: "/course",
    name: "course",
    component: Course,
  },
  {
    path: "/courseSignup",
    name: "courseSignup",
    component: CourseSignup,
  },
  {
    path: "/multiRegistration",
    name: "multiRegistration",
    component: MultiRegistration,
  },
  {
    path: "/registrationComplete",
    name: "registrationComplete",
    component: RegistrationComplete,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/qanda",
    name: "QandA",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/QandA.vue"),
  },
  // 啟用會員
  {
    path: "/activate",
    name: "ActivateUser",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ActivateUser,
  },

  // 使用者
  {
    path: "/member",
    name: "Member",
    component: Member,
  },
  {
    path: "/order",
    name: "Order",
    component: Order,
  },
  {
    path: "/favorite",
    name: "Favorite",
    component: Favorite,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/campRelations",
    name: "CampRelations",
    component: CampRelations,
  },
  // new 必須排在 :id 之前，避免被當成 id。
  {
    path: "/campRelations/new",
    name: "CampRelationForm",
    component: CampRelationForm,
  },
  {
    path: "/campRelations/:id",
    name: "CampRelationEdit", // vue-router 不允許重複 name，編輯與新增各一個
    component: CampRelationForm,
  },
  {
    path: "/accountSecurity",
    name: "AccountSecurity",
    component: AccountSecurity,
  },
  {
    path: "/memberNotification",
    name: "MemberNotification",
    component: MemberNotification,
  },
  {
    path: "/memberNotification/:id",
    name: "MemberNotificationDetail",
    component: MemberNotificationDetail,
  },
  {
    path: "/myCourses",
    name: "MyCourses",
    component: MyCourses,
  },
  {
    path: "/myRegistration",
    name: "MyRegistration",
    component: MyRegistration,
  },
  {
    path: "/myRegistrationDetailed",
    name: "MyRegistrationDetailed",
    component: MyRegistrationDetailed,
  },

  // 最新消息
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/newsDetail",
    name: "NewsDetail",
    component: NewsDetail,
  },

  // 系列課程
  {
    path: "/courseSeries",
    name: "CourseSeries",
    component: CourseSeries,
  },
  {
    path: "/courseSeriesDetails",
    name: "CourseSeriesDetails",
    component: CourseSeriesDetails,
  },
  {
    path: "/Reload",
    name: "Reload",
    component: () => import("../views/Reload.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/Forget.vue"),
  },
  {
    path: "/RegistrationComplete",
    name: "RegistrationComplete",
    component: () => import("../views/RegistrationComplete.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "Home" },
  },
];

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
});

export default router;
